import { render, staticRenderFns } from "./ReportData.vue?vue&type=template&id=5b1ad39b&"
import script from "./ReportData.vue?vue&type=script&lang=js&"
export * from "./ReportData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports